<template>
    <v-app :dark="darkMode" v-resize="onResize">

        <sideNavBar v-if="this.$vuetify.breakpoint.smAndDown"></sideNavBar>

        <v-card flat>

            <v-layout row pb-2>
                <v-flex xs12 md10 offset-md1 lg6 offset-lg3>

                    <v-card class="card--flex-toolbar" :class="($vuetify.breakpoint.mdAndUp)?'elevation-15':''"  :flat="$vuetify.breakpoint.smAndDown">

                        <v-layout>

                            <v-flex shrink v-if="this.$vuetify.breakpoint.mdAndUp">

                                <sideNavBar></sideNavBar>

                            </v-flex>

                            <v-flex style="position: relative;">

                                <keep-alive include="impressum,datenschutz,apps">
                                    <router-view></router-view>
                                </keep-alive>

                            </v-flex>

                        </v-layout>

                    </v-card>

                </v-flex>

            </v-layout>

            <v-snackbar
                v-model="snackbar.isActive"
                :color="snackbar.color"
                :bottom="$vuetify.breakpoint.smAndDown"
                :left="$vuetify.breakpoint.smAndDown"
                :top="$vuetify.breakpoint.mdAndUp"
                :timeout="snackbar.timeout"
                :multi-line="$vuetify.breakpoint.smAndDown"
            >

                <v-layout justify-begin align-center>
                    <v-avatar
                        v-if="snackbar.image"
                        :size="32"
                        color="grey lighten-4"
                        class="mr-4"
                    >
                        <v-img :src="snackbar.image"></v-img>
                    </v-avatar>

                    <span v-html="snackbar.text"></span>
                </v-layout>

            </v-snackbar>

    </v-card>

  </v-app>

</template>

<script>
import resize from 'vue-resize-directive'
import sideNavBar from "./components/elements/sideNavBar"

export default {
    name: 'App',
    directives: {
        resize,
    },
    components: {
        sideNavBar
    },
    data: () => ({
        prevHeight: 0,
        backgroundColorMobile: 'white',
        backgroundColorMobileDark: '',
        backgroundColorDesktop: '#e8eaf6',
        backgroundColorDesktopDark: '#515151',
        styleAppBackground: {
            backgroundColor: null
        },
        loginWithGoogle: false,
        snackbar: {
            isActive: false,
            timeout: 3000,
            text: '',
            position: "bottom",
            color: 'success',
            image: ''
        },
        colors: {
            snackbar: {
                success: "green",
                warning: "orange black--text",
                error: "red",
                info: "black"
            }
        }
    }),
    computed: {

        gName() {
            return this.$store.getters.gName;
        },

        darkMode () {

            return this.$store.getters.darkMode;

        }
    },

    methods: {

        onResize () {
            if ( this.$vuetify.breakpoint.mdAndDown === true ) {
                if ( this.darkMode === true ) {
                    this.styleAppBackground.backgroundColor = this.backgroundColorMobileDark;
                }
                else {
                    this.styleAppBackground.backgroundColor = this.backgroundColorMobile;
                }

            }
            else {
                if ( this.darkMode === true ) {
                    this.styleAppBackground.backgroundColor = this.backgroundColorDesktopDark;
                }
                else {
                    this.styleAppBackground.backgroundColor = this.backgroundColorDesktop;
                }

            }
        }
    },
    mounted: function(){
        this.onResize();

        window.addEventListener('beforeinstallprompt', (e) => {
          e.preventDefault();
          this.$store.dispatch("installPrompt", e);
        });



    },
    beforeCreate: function(){


        // Hier werden die zuletzt gespeicherten Sachen aus dem local Storage geholt
        this.$store.dispatch("initStore");

        this.$store.dispatch("initGoogleSignIn", this.$getGapiClient)
            .then(response => {

                // direkt die Mutation aufrufen zum laden der Standard-Steuersätze und Einstellungen
                // Individuelle Einstellungen und Steuersätze über API laden
                this.$store.dispatch("initStore");

                // Info ob angemeldet oder nicht
                if ( typeof response !== "undefined" && typeof response.email !== "undefined" ) {
                    this.$EventBus.$emit("showSnackbar", { text: response.name + '<br>' + response.email, status: 'info', image: response.image });

                    if ( this.darkMode === true ) {
                        this.$vuetify.theme.primary = '#6BA5ED';
                    }
                    else {
                        this.$vuetify.theme.primary = '#1976d2';
                    }
                }
            });
    },

    created: function() {

        if ( this.darkMode === true ) {
            this.$vuetify.theme.primary = '#6BA5ED';
        }
        else {
            this.$vuetify.theme.primary = '#1976d2';
        }

        this.$EventBus.$on('showSnackbar', payload => {

            this.snackbar.image = ( payload.image ) ? payload.image : "";
            this.snackbar.text = payload.text;
            this.snackbar.isActive = true;

            if ( payload.status === 'success' ) {
                this.snackbar.color = this.colors.snackbar.success;
            }
            else if ( payload.status === "error" ) {
                this.snackbar.color = this.colors.snackbar.error;
            }
            else if ( payload.status === "warning" ) {
                this.snackbar.color = this.colors.snackbar.warning;
            }
            else if ( payload.status === "info" ) {
                this.snackbar.color = this.colors.snackbar.info;
            }

            let snack = this.snackbar;
            setTimeout(function(){
                snack.image = "";
            }, this.snackbar.timeout + 100);
        });
    }
}
</script>

<style>


input[type='number'] {
    -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

div {
    /* Make interactive elements not selectable */
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
}

@media screen and (min-width: 0px) {
    .card--flex-toolbar {
        margin-top: 0;
    }
}

@media screen and (min-width: 960px) {
    .card--flex-toolbar {
        margin-top: 32px;
    }
}

@media screen and (min-width: 1264px) {
    .card--flex-toolbar {
        margin-top: 64px;
    }
}


</style>
